import React from 'react';
import { Icons } from '../../assets';
import { Cred, VISIBILITY_TYPE } from '../../models';
import { getTimeSinceDate } from '../../utils';
import OverlappingProfiles from './overlapping-profiles.component';

type Props = {
  cred: Cred;
};

export const CollaboratorDetails: React.FC<Props> = ({ cred }) => {
  const { collaborators, createdBy } = cred;

  const getCollaboratorsNames = () => {
    if (collaborators.length === 0) return '';
    if (collaborators.length === 1) return ` and ${collaborators[0].displayName}`;
    return ` and ${collaborators.length} more`;
  };

  return (
    <div className="flex items-center justify-between py-2">
      <div className="flex">
        {collaborators.length > 0 ? (
          <div className="relative h-10">
            <OverlappingProfiles
              collaborators={[createdBy, ...collaborators].slice(0, 2)}
            />
          </div>
        ) : (
          <img
            src={createdBy?.profilePictureResource?.url || '/default-profile.png'}
            alt={createdBy?.displayName}
            className="w-10 h-10 rounded-full object-cover"
          />
        )}

        <div className="ml-3">
          <span className="font-semibold text-black">{createdBy.displayName}{getCollaboratorsNames()}</span>
          <div className="flex items-center content-start text-gray-500 text-sm">
            <span>{'\u2022 '}{cred?.createdAt && getTimeSinceDate(cred?.createdAt)}</span>
            <img
              src={cred.visibility === VISIBILITY_TYPE.FAM ? Icons.VISIBILITY_FAM : Icons.VISIBILITY_PUBLIC}
              alt="Visibility Icon"
              className="w-4 h-4 ml-1"
            />
          </div>
        </div>
      </div>

     
    </div>
  );
};
